









import Vue from 'vue';

export default Vue.extend({
    props: {
        links: Array,
        height: Number,
    },
    computed: {
        screenDimensions() {
            return { width: window.innerWidth, height: this.height };
        },
    },
});
